import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-data-info',
  templateUrl: './no-data-info.component.html',
  styleUrls: ['./no-data-info.component.scss']
})
export class NoDataInfoComponent implements OnInit {

  @Input() dataSets: any[][] = []; // Accepts multiple arrays
  @Input() message: string = "No data found.";
  @Input() imageSrc: string = "assets/icons/no-result-img.svg";
  @Input() isimgCentered: string = "";
  @Input() wraperClass: string = "text-center mt-2 mb-1";
  @Input() isloader: boolean = false;
  @Input() disabledImage: boolean = false;
  
  constructor() { }

  ngOnInit() {
  }

  get isAllEmpty(): boolean {
    return this.dataSets.every(arr => Array.isArray(arr) && arr.length === 0);
  }
}
